import UserCredentialList from "@/components/UserCredentialList.vue";
import UserLogoImage from "@/components/UserLogoImage.vue";
import UserSubscriptionHistory from "@/components/UserSubscriptionHistory.vue";
import UserSubscriptionInfo from "@/components/UserSubscriptionInfo.vue";
import { repositories, useCases } from "@/core";
import UserSubscriptionHistoryPresentationMappers from "@/presentation/mappers/UserSubscriptionTransactionPresentationMappers";

export default {
  components: {
    UserSubscriptionHistory,
    UserCredentialList,
    UserSubscriptionInfo,
    UserLogoImage,
  },
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  created() {
    window.addEventListener("resize", this.calculateWidth);
  },
  data() {
    return {
      item: {},
      id: this.$route.params.id,
      loadingItems: false,
      loadingSubscriptions: false,
      subscriptionTransactions: [],
      isCancelable: false,
      crmColumns: [
        { name: "Número" },
        { name: "UF" },
        { name: "Validado" },
        { name: "Ações" },
      ],
      addressColumns: [
        {
          name: "Nome do local",
          sortName: null,
          order: null,
        },
        {
          name: "Endereço",
          sortName: null,
          order: null,
        },
        {
          name: "Complemento",
          sortName: null,
          order: null,
        },
      ],
      columns: [
        {
          name: "Paciente",
          sortName: null,
          order: null,
        },
        {
          name: "Assinatura digital",
          sortName: null,
          order: null,
        },
        {
          name: "Data",
          sortName: null,
          order: null,
        },
        {
          name: "PDF",
          sortName: null,
          order: null,
        },
      ],
    };
  },
  methods: {
    async getData() {
      this.getSubscriptionHistory();
      try {
        let filters = {
          user_id: this.id,
        };
        const res = await repositories.userService.show(this.id, {
          address: true,
          device_information: true,
          crms: true,
        });
        const medicalRecords = await repositories.medicalRecordsService.list(
          filters,
        );
        const prescriptions = await repositories.prescriptionsService.list(
          filters,
        );

        let data = res.data;
        data.medicalRecords = medicalRecords.data;
        data.prescriptions = prescriptions.data;

        this.$set(this, "item", data);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingItems = false;
      }
    },
    async getSubscriptionHistory() {
      try {
        this.loadingSubscriptions = true;
        const result =
          await useCases.listUserSubscriptionHistoryUseCase.execute(this.id);
        console.log("result", JSON.stringify(result));
        this.subscriptionTransactions =
          UserSubscriptionHistoryPresentationMappers.toListViewModel(result);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingSubscriptions = false;
      }
    },
    openPDF(item) {
      if (item.pdf_url) {
        window.open(
          `${process.env.VUE_APP_IMG_BASE_URL}${item.pdf_url}`,
          "_blank",
        );
      }
    },
    async handlePremium() {
      this.$eventBus.$emit("showConfirmationAlert", {
        title: this.item.isPremium ? "Remover Premium" : "Tornar Premium",
        message: this.item.isPremium
          ? "Deseja remover a assinatura premium para este usuário?"
          : "Deseja dar uma assinatura premium para este usuário?",
        confirmCallback: async () => {
          try {
            this.loadingItems = true;
            if (this.item.isPremium) {
              await repositories.userService.unsubscribeUser({
                user_id: this.id,
              });
              this.$eventBus.$emit("showToast", {
                title: "Assinatura removida",
                msg: `Assinatura removida com sucesso`,
              });
            } else {
              await repositories.userService.subscribeUser({
                user_id: this.id,
              });
              this.$eventBus.$emit("showToast", {
                title: "Assinatura efetuada",
                msg: `Assinatura efetuada com sucesso`,
              });
            }
            this.getData();
          } catch (e) {
            console.log(e);
          }
        },
      });
    },
    async handleBlock() {
      this.$eventBus.$emit("showConfirmationAlert", {
        title: this.item.active ? "Bloquear Usuário" : "Desbloquear Usuário",
        message: this.item.active
          ? "Deseja bloquear este usuário?"
          : "Deseja desbloquear este usuário?",
        confirmCallback: async () => {
          try {
            this.loadingItems = true;
            await repositories.userService.update(this.id, {
              active: !this.item.active,
            });
            this.$eventBus.$emit("showToast", {
              title: this.item.active
                ? "Usuário bloqueado"
                : "Usuário desbloqueado",
              msg: this.item.active
                ? `Usuário bloqueado com sucesso`
                : "Usuário desbloqueado com sucesso",
            });
            this.getData();
          } catch (e) {
            console.log(e);
          }
        },
      });
    },
    onCrmsUpdated() {
      this.loadingItems = true;
      this.getData();
    },
  },
};
